export const requestExecutionStateKey = (documentId: string, pageId: string) =>
	`request-page:${documentId}:${pageId}`;
